import {
  AfterContentInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
} from "@angular/core";
import { AbstractControl, ControlContainer, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subject, merge, startWith, takeUntil } from "rxjs";

@Directive({
  selector: "[formControlError]",
  standalone: true,
})
export class FormErrorDirective implements OnDestroy, AfterContentInit {
  @Input()
  formControlError: string;

  @Input()
  control: AbstractControl;

  private unsubscribe$: Subject<void> = new Subject<void>();

  public supportedRuleMessage = {
    required: "VALIDATIONS.REQUIRED",
    fileExtension: "VALIDATIONS.FILE_EXTENSION",
    fileTypeExtension: "VALIDATIONS.FILE_EXTENSION",
    fileSizeExtension: "VALIDATIONS.FILE_MAXIMUM_SIZE",
    max: "VALIDATIONS.MAX_NUMBER",
    min: "VALIDATIONS.MIN_NUMBER",
    maxlength: "VALIDATIONS.MAX_LENGTH",
    minlength: "VALIDATIONS.MIN_LENGTH",
    email: "VALIDATIONS.EMAIL_INVALID",
    pattern: "VALIDATIONS.PATTERN_INVALID",
  };

  public get message() {
    return this.el.nativeElement.innerText;
  }
  public set message(value) {
    this.el.nativeElement.innerText = value;
  }

  constructor(
    private translateService: TranslateService,
    private controlContainer: ControlContainer,
    private el: ElementRef
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterContentInit() {
    if (!this.control) {
      const group = <FormGroup>this.controlContainer.control;
      this.control = group.get(this.formControlError);
    }
    if (!this.control) {
      return;
    }
    merge([this.control.valueChanges, this.control.statusChanges])
      .pipe(startWith(""), takeUntil(this.unsubscribe$))
      .subscribe(() => {
        try {
          this.updateMessage();
        } catch (e) {
          console.error(e);
        }
      });
    // contentChildren is set
  }

  updateMessage() {
    try {
      const errors = { ...this.control.errors };
      if (!errors) {
        this.message = "";
      }
      const keys = Object.keys(errors);
      const key = keys.find((k) => !!this.supportedRuleMessage[k]);
      if (!key) {
        this.message = "";
      }
      const message = this.supportedRuleMessage[key];
      this.message = this.translateService.instant(message, errors[key]);
    } catch (e) {
      this.message = "";
    }
  }
}
